import { computed, Injectable } from '@angular/core';
import { ComponentStoreV2Factory } from '../../../../shared/store/common/component-store-v2.factory';

@Injectable()
export class VoucherDetailPageStore2 extends ComponentStoreV2Factory {

    public currentService = computed(() => this.globalGlobalStore.organizationStore.getServiceBySignalId(this.globalGlobalStore.loggedUserStore.selectedServiceId)());

}
